export function formatPhoneNumber(phoneNumber) {
  const cleaned = `${phoneNumber}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);

  if (match && match[1] === '010') {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  return phoneNumber;
}